import { useEffect, useState } from 'react';
import { httpClient, uploadClient } from "../../../util/Api";
import { setInitUrl } from "appRedux/actions";
import { useDispatch } from "react-redux";
import * as globalFunction from 'util/GlobalFunction';

export const useProvideAuth = () => {
  const [authUser, setAuthUser] = useState(null);
  const [error, setError] = useState('');
  const [isLoadingUser, setLoadingUser] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [loginSecurityCodeData, setLoginSecurityCodeData] = useState({});
  const [showLoginSecurityCode, setShowLoginSecurityCode] = useState(false);
  const dispatch = useDispatch();

  const fetchStart = () => {
    setLoading(true);
    setError('');
  };

  const fetchSuccess = () => {
    setLoading(false);
    setError('');
  };

  const fetchError = (error) => {
    setLoading(false);
    setError(error);
  };

  const userLogin = (user, callbackFun) => {
    fetchStart();
    httpClient
      .post('System/Login/LoginForClientUser', user)
      .then(({ data }) => {
        if (data.result) {
          if (data.code === 0) {
            fetchSuccess();
            httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + data.data;
            uploadClient.defaults.headers.common['Authorization'] = 'Bearer ' + data.data;
            localStorage.setItem('token', data.data);
            getAuthUser();
            if (callbackFun) callbackFun();
          }
          if (data.code === 2) {
            data.Remember = user.Remember === true ? true : false;
            setLoginSecurityCodeData(data);
            setShowLoginSecurityCode(true);
            setLoading(false);
          }
        } else {
          fetchError(data.message);
        }
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  };

  const checkLoginSecurityCode = (user, callbackFun) => {
    fetchStart();
    httpClient
      .post('System/Login/CheckLoginSecurityCode', user)
      .then(({ data }) => {
        if (data.result) {
          fetchSuccess();
          setShowLoginSecurityCode(false);
          httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + data.data;
          uploadClient.defaults.headers.common['Authorization'] = 'Bearer ' + data.data;
          localStorage.setItem('token', data.data);
          getAuthUser();
          if (callbackFun) callbackFun();
        } else {
          fetchError(data.message);
        }
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  }

  const userSignup = (user, callbackFun) => {
    fetchStart();
    httpClient
      .post('auth/register', user)
      .then(({ data }) => {
        if (data.result) {
          fetchSuccess();
          localStorage.setItem('token', data.data);
          httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + data.data;
          uploadClient.defaults.headers.common['Authorization'] = 'Bearer ' + data.data;
          getAuthUser();
          if (callbackFun) callbackFun();
        } else {
          fetchError(data.message);
        }
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  };

  const sendPasswordResetEmail = (email, callbackFun) => {
    fetchStart();

    setTimeout(() => {
      fetchSuccess();
      if (callbackFun) callbackFun();
    }, 300);
  };

  const confirmPasswordReset = (code, password, callbackFun) => {
    fetchStart();

    setTimeout(() => {
      fetchSuccess();
      if (callbackFun) callbackFun();
    }, 300);
  };

  const renderSocialMediaLogin = () => null;

  const userSignOut = (callbackFun) => {
    httpClient.defaults.headers.common['Authorization'] = '';
    uploadClient.defaults.headers.common['Authorization'] = '';
    localStorage.removeItem('token');
    fetchSuccess();
    setAuthUser(false);
    dispatch(setInitUrl('/jobs'));
    if (callbackFun) callbackFun();

    // fetchStart();
    httpClient
      .post('System/Login/Logout')
      .then(({ data }) => {
        if (data.result) {
          // httpClient.defaults.headers.common['Authorization'] = '';
          // uploadClient.defaults.headers.common['Authorization'] = '';
          // localStorage.removeItem('token');
          // fetchSuccess();
          // setAuthUser(false);
          // if (callbackFun) callbackFun();
        } else {
          fetchError(data.message);
        }
      })
      .catch(function (error) {
        fetchError(error.message);
      });
  };

  const getAuthUser = () => {
    fetchStart();
    httpClient
      .post('System/Authentication/ClientUser')
      .then(({ data }) => {
        if (data.result) {
          fetchSuccess();
          let clientUser = data.data;
          globalFunction.decompressData(clientUser.webUIConfig).then(function (data) {
            clientUser.webUIConfig = data;
            console.log(clientUser);
            setAuthUser(clientUser);
            setLoadingUser(false);
          }).catch(function (error) {
            // 处理错误
            console.error(error);
            setLoadingUser(false);
          });
        } else {
          fetchError(data.message);
        }
      })
      .catch(function (error) {
        // httpClient.defaults.headers.common['Authorization'] = '';
        // uploadClient.defaults.headers.common['Authorization'] = '';
        fetchError(error.message);
      });
  };

  // Subscribe to user on mount
  // Because this sets state in the callback it will cause any ...
  // ... component that utilizes this hook to re-render with the ...
  // ... latest auth object.

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      uploadClient.defaults.headers.common['Authorization'] = 'Bearer ' + token;

      httpClient
        .post('System/Authentication/ClientUser')
        .then(({ data }) => {
          if (data.result) {
            let clientUser = data.data;
            globalFunction.decompressData(clientUser.webUIConfig).then(function (data) {
              clientUser.webUIConfig = data;
              console.log(clientUser);
              setAuthUser(clientUser);
              setLoadingUser(false);
            }).catch(function (error) {
              // 处理错误
              console.error(error);
              setLoadingUser(false);
            });
          } else {
            setLoadingUser(false);
          }
        })
        .catch(function () {
          // localStorage.removeItem('token');
          // httpClient.defaults.headers.common['Authorization'] = '';
          // uploadClient.defaults.headers.common['Authorization'] = '';
          setLoadingUser(false);
        });
    } else {
      localStorage.removeItem('token');
      httpClient.defaults.headers.common['Authorization'] = '';
      uploadClient.defaults.headers.common['Authorization'] = '';
      setLoadingUser(false);
    }
  }, []);

  // Return the user object and auth methods
  return {
    isLoadingUser,
    isLoading,
    authUser,
    error,
    setError,
    setAuthUser,
    getAuthUser,
    userLogin,
    userSignup,
    userSignOut,
    renderSocialMediaLogin,
    sendPasswordResetEmail,
    confirmPasswordReset,
    loginSecurityCodeData,
    showLoginSecurityCode,
    setShowLoginSecurityCode,
    checkLoginSecurityCode
  };
};
